<template>
    <div class="chart-container">
        <svg ref="chart" class="chart-content" :height="elementHeight + 'px'" width="100%">
            <defs>
                <pattern v-for="point in data.points" v-bind:key="point.id" v-bind:id="point.id + 'bar'" :width="point.parties.length * 8" :height="point.parties.length * 8" patternTransform="rotate(60 0 0)" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" :width="point.parties.length * 8" :height="point.parties.length * 8" fill="white"/>
                    <line v-for="(party, i) in point.parties" v-bind:key="i" :x1="4 + i*8" y1="0" :x2="4 + i*8" :y2="point.parties.length * 8" :class="['stroke-party-' + party]" :style="{'stroke-width': 8}" />
                </pattern>
            </defs>
            <g :transform="'translate(' + margin.left + ', ' + margin.top + ')'">
                <g v-for="(point, i) in data.points" :key="point.id">
                    <rect class="bar"  :class="{'hover': point.id == hover}" x="0" :y="yScale(point.title)" :height="barwidth" :width="xScale(point.estimate)" 
                    :fill = "'url(#' + point.id + 'bar)'" @mouseenter="hovered(point, i)"/>
                    <g :transform="'translate(' + xScale(point.estimate) + ', ' + (yScale(point.title) + barwidth / 2) + ')'" v-if="point.id == hover">
                        <text dominant-baseline="middle" x="7" class="note active">{{ point.x | percentage(0) }}</text>
                    </g>
                </g>
            </g>
            <g :transform="'translate(0, ' + margin.top + ')'" text-anchor="start">
                <g v-for="(tick, i) in yTicks" :key="i" class="tick" :class="{'hover': tick.id == hover}" :transform="'translate(0, ' + tick.y + ')'">
                    <text x="9" dy="0.32em" @mouseenter="hovered(tick, i)" class="note" :class="{active: (tick.id == hover)}">{{ tick.text }}</text>
                </g>
            </g>
            <g :transform="'translate(' + margin.left + ', ' + (margin.top + height) + ')'" text-anchor="middle">
                <g v-for="(tick, i) in xTicks" :key="i" class="tick" :transform="'translate(' + tick.x + ', 0)'">
                    <text class="label" y="9" dy="0.71em">{{ tick.text }}</text>
                </g>
            </g>
            <g :transform="'translate(' + margin.left + ', ' + (margin.top) + ')'">
                <g v-for="(tick, i) in xTicks" :key="i" class="tick" :transform="'translate(' + tick.x + ', 0)'">
                    <line :y2="height" class="grid"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
import * as d3 from "d3";
import { max, map } from "lodash";

export default {
    name: 'BarChart',
    props: ["data", "elementHeight"],
    data () {
        return {
            margin: {top: 10, right: 20, bottom: 30, left: 180},
            clientWidth: 600,
            hover: null
        }
    },
    computed: {
        labels() {
            return map(this.data.points, "title")
        },
        width () {
            return this.clientWidth - this.margin.left - this.margin.right;
        },
        height () {
            return this.elementHeight - this.margin.top - this.margin.bottom;
        },
        barwidth () {
            return this.yScale.bandwidth();
        },
        maxX () {
            let val = max(map(this.data.points, "x"));

            return val ? (val + 0.1) : 1;
        },
        yScale () {
            return d3.scaleBand().domain(this.labels).range([0, this.height]).padding(0.3);
        },
        yTicks () {
            return map(this.data.points, o => ({y: this.yScale(o.title) + this.barwidth / 2, text: o.title, id: o.id}));
        },
        xScale () {
            return d3.scaleLinear().domain([0, this.maxX]).range([0, this.width]);
        },
        xTicks () {
            let x = this.xScale.ticks(5);
            let format = this.xScale.tickFormat(5, "%");


            return map(x, (o) => ({x: this.xScale(o), text: format(o)}));
        },
    },
    mounted () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize () {
            if (this.$refs.chart) {
                this.clientWidth = this.$refs.chart.clientWidth;
            }
        },
        hovered (point) {
            this.hover = point.id;
            this.$emit('hover', point.id);
        }
    }
}
</script>

<style scoped>
@keyframes slideInFromLeft {
  0% {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }
  15% {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);

  }
  100% {
   clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
  }
}

rect.bar {
  animation: 1.5s ease-in-out 0s 1 slideInFromLeft;
}
</style>